/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let moldeEnProceso = false;
let cartRefreshOrigin = null;

document.addEventListener('product:added', function(event) {
  var variant = event.detail.variant;
  var quantity = event.detail.quantity;

  console.log("🟠 product:added escuchado", variant, quantity);

  if (
    variant &&
    variant.product_title &&
    (variant.product_title.toLowerCase().includes("mold fee") ||
     variant.product_title.toLowerCase().includes("customization fee"))
  ) {
    console.log("⚠️ [product:added] Es el molde el que se agregó. Abortamos lógica.");
    return;
  }

  if (variant && variant.product_title && variant.product_title.toLowerCase().includes("personalize")) {
    console.log("✅ [product:added] Producto personalizado agregado. Ejecutando actualizarTodosLosMoldes...");
    // Add small delay to ensure cart is updated
    setTimeout(() => {
      actualizarTodosLosMoldes();
    }, 200);
  }
});

// ✅ RESTORED: Original working cart:refresh logic
document.addEventListener('cart:refresh', () => {
  console.log("✅ cart:refresh escuchado → Recalculando moldes...");

  if (cartRefreshOrigin === "molde") {
    console.log("🛑 cart:refresh viene del molde. Evitamos recalcular moldes nuevamente.");
    cartRefreshOrigin = null;
    return;
  }

  console.log("✅ [cart:refresh] Proviene del usuario o del theme → recalculando moldes...");
  // Add delay to prevent race conditions
  setTimeout(() => {
    actualizarTodosLosMoldes();
  }, 300);
});

// ✅ Listen for quantity button clicks in cart drawer
document.addEventListener('click', function(event) {
  const quantityButton = event.target.closest('[data-action="increment-quantity"], [data-action="decrement-quantity"], .quantity-selector button, .cart-item__quantity button, .js-qty__adjust');
  
  if (quantityButton) {
    console.log("🔢 [quantity-button] Quantity button clicked, will trigger mold recalculation...");
    
    setTimeout(() => {
      console.log("🔢 [quantity-button] Triggering cart refresh after quantity change...");
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }, 500);
  }
});

// ✅ Listen for any cart quantity changes
document.addEventListener('change', function(event) {
  const quantityInput = event.target.closest('input[name*="quantity"], input[data-quantity-input], .cart-item__quantity input, .quantity-selector input');
  
  if (quantityInput) {
    console.log("🔢 [quantity-input] Quantity input changed, will trigger mold recalculation...");
    
    setTimeout(() => {
      console.log("🔢 [quantity-input] Triggering cart refresh after quantity change...");
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }, 500);
  }
});

// ✅ ENHANCED: Better fetch interceptor for cart operations
const originalFetch = window.fetch;
window.fetch = function(...args) {
  const url = args[0];
  const options = args[1] || {};
  
  // Only intercept specific cart update endpoints
  if (typeof url === 'string' && (url.includes('/cart/change.js') || url.includes('/cart/update.js'))) {
    console.log("🌐 [fetch-interceptor] Cart update request detected:", url);
    
    // Check if this is a removal (quantity: 0)
    let isRemoval = false;
    if (options.body) {
      try {
        const body = JSON.parse(options.body);
        if (body.quantity === 0) {
          isRemoval = true;
          console.log("🗑️ [fetch-interceptor] Detected item removal via fetch");
        }
      } catch (e) {
        // If body is not JSON, check if it's a URL-encoded string
        if (typeof options.body === 'string' && options.body.includes('quantity=0')) {
          isRemoval = true;
          console.log("🗑️ [fetch-interceptor] Detected item removal via URL-encoded body");
        }
      }
    }
    
    return originalFetch.apply(this, args).then(response => {
      if (response.ok) {
        console.log("🌐 [fetch-interceptor] Cart update successful, will trigger mold recalculation...");
        // Only trigger if it's not from our mold operations
        if (cartRefreshOrigin !== "molde") {
          const delay = isRemoval ? 1000 : 400; // ✅ FIXED: Longer delay for removals
          setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          }, delay);
          
          // ✅ FIXED: Additional attempt for removals to ensure mold is removed
          if (isRemoval) {
            setTimeout(() => {
              console.log("🗑️ [fetch-interceptor] Additional removal attempt");
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }, delay + 1000);
          }
        }
      }
      return response;
    });
  }
  
  return originalFetch.apply(this, args);
};

// ✅ NEW: Process ALL images that have personalized products in cart
function actualizarTodosLosMoldes(retryCount = 0) {
  console.log(`🔵 [actualizarTodosLosMoldes] llamada → retryCount=${retryCount}, moldeEnProceso=${moldeEnProceso}`);

  if (moldeEnProceso) {
    console.log("🛑 [actualizarTodosLosMoldes] Ya hay un proceso en curso. Abortando.");
    return;
  }

  moldeEnProceso = true;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log("🟢 [actualizarTodosLosMoldes] Carrito obtenido:", cart);

      // Find all unique images that have personalized products
      const imagenesEnCarrito = new Set();
      
      cart.items.forEach(item => {
        if (
          item.product_title &&
          item.product_title.toLowerCase().includes("personalize") &&
          item.properties &&
          item.properties["Custom Image"]
        ) {
          imagenesEnCarrito.add(item.properties["Custom Image"]);
        }
      });

      console.log("🖼️ [actualizarTodosLosMoldes] Imágenes encontradas en carrito:", Array.from(imagenesEnCarrito));

      // Also find all images that have existing molds (in case items were removed)
      const imagenesConMoldes = new Set();
      cart.items.forEach(item => {
        if (
          item.product_title &&
          (item.product_title.toLowerCase().includes("mold fee") ||
           item.product_title.toLowerCase().includes("customization fee")) &&
          item.properties &&
          item.properties["Mold Reference"]
        ) {
          imagenesConMoldes.add(item.properties["Mold Reference"]);
        }
      }); 

      console.log("🔧 [actualizarTodosLosMoldes] Imágenes con moldes existentes:", Array.from(imagenesConMoldes));

      // Combine both sets to process all images that need attention
      const todasLasImagenes = new Set([...imagenesEnCarrito, ...imagenesConMoldes]);
      console.log("🎯 [actualizarTodosLosMoldes] Todas las imágenes a procesar:", Array.from(todasLasImagenes));

      if (todasLasImagenes.size === 0) {
        console.log("✅ [actualizarTodosLosMoldes] No hay imágenes para procesar.");
        moldeEnProceso = false;
        return;
      }

      // Process each image sequentially
      const imagenesArray = Array.from(todasLasImagenes);
      procesarImagenesSecuencialmente(imagenesArray, cart, 0, retryCount);
    })
    .catch(err => {
      console.error("❌ Error en fetch cart.js:", err);
      moldeEnProceso = false;
    });
}

function procesarImagenesSecuencialmente(imagenesArray, cart, index, retryCount) {
  if (index >= imagenesArray.length) {
    console.log("✅ [procesarImagenesSecuencialmente] Todas las imágenes procesadas.");
    moldeEnProceso = false;
    return;
  }

  const imageUrl = imagenesArray[index];
  console.log(`🔄 [procesarImagenesSecuencialmente] Procesando imagen ${index + 1}/${imagenesArray.length}: ${imageUrl}`);

  // Process this specific image
  actualizarMoldePorImagen(imageUrl, cart, () => {
    // Continue with next image
    procesarImagenesSecuencialmente(imagenesArray, cart, index + 1, retryCount);
  });
}

function actualizarMoldePorImagen(imageUrl, cart, callback) {
  console.log(`🔵 [actualizarMoldePorImagen] Procesando imagen: ${imageUrl}`);

  // ✅ FIXED: Check if this image already has a Classic Mold in the cart
  const existingClassicMold = cart.items.find(item =>
    item.product_title &&
    (item.product_title.toLowerCase().includes("mold fee") ||
     item.product_title.toLowerCase().includes("customization fee")) &&
    item.properties &&
    item.properties["Mold Reference"] === imageUrl &&
    item.properties["DIY Method"] === "Classic Mold"
  );

  // ✅ FIXED: If Classic Mold exists, preserve it (don't change to Custom Mold logic)
  const shouldUseClassicMold = !!existingClassicMold;
  
  // ✅ FALLBACK: Also check localStorage for current image being processed
  const hasOriginalMold = localStorage.getItem("hasOriginalMold") === "true";
  const currentImageUrl = localStorage.getItem("customImageURL");
  const isCurrentImageWithOriginalMold = imageUrl === currentImageUrl && hasOriginalMold;

  // ✅ COMBINED LOGIC: Use Classic Mold if it exists OR if it's the current image with hasOriginalMold
  const shouldUseOriginalMoldLogic = shouldUseClassicMold || isCurrentImageWithOriginalMold;

  console.log("[actualizarMoldePorImagen] existingClassicMold:", !!existingClassicMold);
  console.log("[actualizarMoldePorImagen] shouldUseClassicMold:", shouldUseClassicMold);
  console.log("[actualizarMoldePorImagen] isCurrentImageWithOriginalMold:", isCurrentImageWithOriginalMold);
  console.log("[actualizarMoldePorImagen] shouldUseOriginalMoldLogic:", shouldUseOriginalMoldLogic);

  // Count personalized products for this specific image
  let qty = 0;
  cart.items.forEach(item => {
    if (
      item.product_title &&
      item.product_title.toLowerCase().includes("personalize") &&
      item.properties &&
      item.properties["Custom Image"] === imageUrl
    ) {
      qty += item.quantity;
    }
  });

  console.log(`[actualizarMoldePorImagen] qty productos personalizados para ${imageUrl}:`, qty);

  // If no personalized products, remove all molds for this image
  if (qty === 0) {
    console.log("🔴 [actualizarMoldePorImagen] No hay productos suficientes. Eliminando moldes para esta imagen.");
    eliminarMoldesPorImagen(imageUrl, callback);
    return;
  }

  let targetVariantId = null;
  let moldFeeType = null;

  // 🟤 Lógica especial para molde fijo (Classic Mold)
  if (shouldUseOriginalMoldLogic) {
    targetVariantId = 46462300782822; // Fixed variant for Classic Mold
    moldFeeType = "Classic Mold";
    console.log("🟤 [actualizarMoldePorImagen] Usando lógica Classic Mold");
  } else {
    // 🟡 Lógica estándar (Custom Mold)
    console.log("🟡 [actualizarMoldePorImagen] Usando lógica Custom Mold");
    
    if (qty >= 10) {
      targetVariantId = 46451336184038; // Gratis
    } else if (qty >= 5) {
      targetVariantId = 46451335463142; // $125
    } else if (qty > 0) {
      targetVariantId = 46429237215462; // $250
    }
    
    moldFeeType = "Custom Mold";
  }

  console.log("[actualizarMoldePorImagen] targetVariantId elegido:", targetVariantId);
  console.log("[actualizarMoldePorImagen] moldFeeType:", moldFeeType);

  // ✅ ENHANCED: Find molds for this specific image and fee type
  const moldes = cart.items.filter(item =>
    item.product_title &&
    (item.product_title.toLowerCase().includes("mold fee") ||
     item.product_title.toLowerCase().includes("customization fee")) &&
    item.properties &&
    item.properties["Mold Reference"] === imageUrl &&
    item.properties["DIY Method"] === moldFeeType
  );

  // ✅ CRITICAL FIX: Also remove any molds of the WRONG type for this image
  const wrongTypeMolds = cart.items.filter(item =>
    item.product_title &&
    (item.product_title.toLowerCase().includes("mold fee") ||
     item.product_title.toLowerCase().includes("customization fee")) &&
    item.properties &&
    item.properties["Mold Reference"] === imageUrl &&
    item.properties["DIY Method"] !== moldFeeType
  );

  console.log("[actualizarMoldePorImagen] Moldes correctos encontrados:", moldes.length);
  console.log("[actualizarMoldePorImagen] Moldes de tipo incorrecto encontrados:", wrongTypeMolds.length);

  // Check if we already have the correct mold
  const correctMold = moldes.find(molde =>
    molde.variant_id === targetVariantId && molde.quantity === 1
  );

  const incorrectQuantityMolds = moldes.filter(molde =>
    molde.variant_id === targetVariantId && molde.quantity > 1
  );

  // If we have the correct mold and no wrong types, we're done
  if (correctMold && moldes.length === 1 && wrongTypeMolds.length === 0 && incorrectQuantityMolds.length === 0) {
    console.log("✅ [actualizarMoldePorImagen] Molde correcto ya existe para esta imagen.");
    callback();
    return;
  }

  // ✅ CRITICAL FIX: Remove ALL existing molds for this image (both correct and wrong types)
  const allMoldsToRemove = [...moldes, ...wrongTypeMolds];
  console.log("🧽 [actualizarMoldePorImagen] Eliminando todos los moldes existentes para esta imagen:", allMoldsToRemove.length);
  
  const deletePromises = allMoldsToRemove.map(molde => {
    console.log("🧽 [actualizarMoldePorImagen] Eliminando molde:", {
      key: molde.key,
      variant_id: molde.variant_id,
      quantity: molde.quantity,
      type: molde.properties["DIY Method"]
    });
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: molde.key, quantity: 0 })
    });
  });

  Promise.all(deletePromises)
    .then(() => {
      console.log("🟢 [actualizarMoldePorImagen] Moldes eliminados, agregando nuevo molde...");
      // Add delay before adding new mold to ensure deletions are processed
      setTimeout(() => {
        addMoldePorImagen(targetVariantId, imageUrl, moldFeeType, callback);
      }, 300);
    })
    .catch(err => {
      console.error("❌ [actualizarMoldePorImagen] Error eliminando moldes antiguos:", err);
      callback();
    });
}

function addMoldePorImagen(variantId, imageUrl, moldFeeType, callback) {
  console.log("🟡 [addMoldePorImagen] Ejecutando addMolde con variantId:", variantId, "para imagen:", imageUrl);

  cartRefreshOrigin = "molde"; // Set this BEFORE making the request

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1, // ✅ FIXED: Always add exactly 1 mold
      properties: {
        "Mold Reference": imageUrl,
        "DIY Method": moldFeeType
      }
    })
  })
  .then(response => response.json())
  .then((data) => {
    console.log("✅ [addMoldePorImagen] Molde agregado:", data);
    callback();
  })
  .catch(err => {
    console.error("❌ [addMoldePorImagen] Error al agregar molde:", err);
    cartRefreshOrigin = null; // Reset on error
    callback();
  });
}

// ✅ ENHANCED: Better mold removal with verification
function eliminarMoldesPorImagen(imageUrl, callback) {
  console.log("🧹 [eliminarMoldesPorImagen] Eliminando moldes para imagen:", imageUrl);

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Find all molds related to this specific image
      const moldes = cart.items.filter(item => {
        const isMoldFee = item.product_title &&
          (item.product_title.toLowerCase().includes("mold fee") ||
           item.product_title.toLowerCase().includes("customization fee"));
        const hasMatchingImage = item.properties &&
          item.properties["Mold Reference"] === imageUrl;
        return isMoldFee && hasMatchingImage;
      });


      console.log("[eliminarMoldesPorImagen] Moldes encontrados para esta imagen:", moldes.length);
      moldes.forEach(molde => {
        console.log("  - Molde a eliminar:", {
          key: molde.key,
          title: molde.product_title,
          properties: molde.properties
        });
      });

      if (moldes.length === 0) {
        console.log("✅ [eliminarMoldesPorImagen] No hay moldes para eliminar.");
        callback();
        return;
      }

      cartRefreshOrigin = "molde";

      const deletePromises = moldes.map(molde => {
        console.log(`⚠️ [eliminarMoldesPorImagen] Eliminando molde: key=${molde.key}, title=${molde.product_title}`);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: molde.key,
            quantity: 0
          })
        }).then(response => {
          console.log(`✅ Delete response for ${molde.key}:`, response.status, response.ok);
          if (!response.ok) {
            throw new Error(`Failed to delete mold ${molde.key}: ${response.status}`);
          }
          return response;
        });
      });

      Promise.all(deletePromises)
        .then(() => {
          console.log("✅ [eliminarMoldesPorImagen] Moldes eliminados correctamente.");
          
          // ✅ FIXED: Add verification step to ensure molds were actually removed
          setTimeout(() => {
            fetch('/cart.js')
              .then(res => res.json())
              .then(verifyCart => {
                const remainingMolds = verifyCart.items.filter(item =>
                  item.product_title &&
                  (item.product_title.toLowerCase().includes("mold fee") ||
                   item.product_title.toLowerCase().includes("customization fee")) &&
                  item.properties &&
                  item.properties["Mold Reference"] === imageUrl
                );
                console.log("🔍 Verification: Remaining molds for", imageUrl, ":", remainingMolds.length);
                if (remainingMolds.length > 0) {
                  console.warn("⚠️ Some molds were not removed, retrying...");
                  // Retry removal for remaining molds
                  const retryPromises = remainingMolds.map(molde => 
                    fetch('/cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ id: molde.key, quantity: 0 })
                    })
                  );
                  Promise.all(retryPromises).then(() => callback()).catch(() => callback());
                } else {
                  callback();
                }
              })
              .catch(() => callback());
          }, 500);
        })
        .catch(err => {
          console.error("❌ [eliminarMoldesPorImagen] Error eliminando moldes:", err);
          cartRefreshOrigin = null;
          callback();
        });
    })
    .catch(err => {
      console.error("❌ [eliminarMoldesPorImagen] Error fetching cart:", err);
      callback();
    });
}

function eliminarTodosLosMoldesGlobal() {
  console.log("🧹 [eliminarTodosLosMoldesGlobal] Eliminando TODOS los moldes del carrito.");

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Find ALL molds in cart
      const moldes = cart.items.filter(item => {
        return item.product_title &&
          (item.product_title.toLowerCase().includes("mold fee") ||
           item.product_title.toLowerCase().includes("customization fee"));
      });

      console.log("[eliminarTodosLosMoldesGlobal] Moldes encontrados:", moldes.length);

      if (moldes.length === 0) {
        console.log("✅ [eliminarTodosLosMoldesGlobal] No hay moldes para eliminar.");
        moldeEnProceso = false;
        return;
      }

      cartRefreshOrigin = "molde";

      const deletePromises = moldes.map(molde => {
        console.log(`⚠️ [eliminarTodosLosMoldesGlobal] Eliminando molde: key=${molde.key}, title=${molde.product_title}`);
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: molde.key,
            quantity: 0
          })
        });
      });

      Promise.all(deletePromises)
        .then(() => {
          console.log("✅ [eliminarTodosLosMoldesGlobal] Todos los moldes eliminados correctamente.");
          
          setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          }, 100);
        })
        .catch(err => {
          console.error("❌ [eliminarTodosLosMoldesGlobal] Error eliminando moldes:", err);
          cartRefreshOrigin = null;
        })
        .finally(() => {
          moldeEnProceso = false;
        });
    })
    .catch(err => {
      console.error("❌ [eliminarTodosLosMoldesGlobal] Error fetching cart:", err);
      moldeEnProceso = false;
    });
}

// ✅ LEGACY FUNCTIONS (kept for backward compatibility)
function actualizarMoldeUpload(retryCount = 0) {
  console.log("⚠️ [actualizarMoldeUpload] DEPRECATED - Redirecting to actualizarTodosLosMoldes");
  actualizarTodosLosMoldes(retryCount);
}

function addMolde(variantId, imageUrl, moldFeeType, retryCount = 0) {
  console.log("⚠️ [addMolde] DEPRECATED - Redirecting to addMoldePorImagen");
  addMoldePorImagen(variantId, imageUrl, moldFeeType, () => {
    setTimeout(() => {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }, 100);
    moldeEnProceso = false;
  });
}

function eliminarTodosLosMoldes(imageUrl) {
  console.log("⚠️ [eliminarTodosLosMoldes] DEPRECATED - Redirecting to eliminarMoldesPorImagen");
  eliminarMoldesPorImagen(imageUrl, () => {
    setTimeout(() => {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }, 100);
    moldeEnProceso = false;
  });
}

// ✅ ENHANCED: Better remove button listener with comprehensive selectors
document.addEventListener('click', function(event) {
  const removeSelectors = [
    '[data-action="remove-item"]',
    '.cart-item__remove',
    '.js-cart-remove',
    '.remove-item',
    '.cart-remove',
    '[data-remove]',
    '.btn-remove',
    '.cart-item__delete',
    '.js-remove-item',
    '.cart__remove',
    '.cart-item-remove',
    '.remove-from-cart',
    '.cart-remove-btn',
    '.item-remove',
    '.delete-item',
    '.cart-delete',
    '[data-cart-remove]',
    '[data-item-remove]',
    '[href*="/cart/change.js"]',
    '[onclick*="cart/change"]',
    '[onclick*="quantity: 0"]',
    '.remove',
    '.delete',
    '[data-line-item-remove]',
    '.line-item-remove',
    '.quantity-remove',
    '[title*="Remove"]',
    '[title*="Delete"]',
    '[aria-label*="Remove"]',
    '[aria-label*="Delete"]'
  ];
  
  const removeButton = event.target.closest(removeSelectors.join(', '));
  
  if (removeButton) {
    console.log("🗑️ [remove-button] Remove button clicked, will trigger mold recalculation...");
    
    // ✅ FIXED: Multiple attempts with longer delays for removal
    setTimeout(() => {
      console.log("🗑️ [remove-button] First attempt - triggering cart refresh after item removal...");
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }, 800); // Increased delay
    
    // Second attempt with even longer delay
    setTimeout(() => {
      console.log("🗑️ [remove-button] Second attempt - triggering cart refresh after item removal...");
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }, 1800);
  }
});

// ✅ SEPARATE HEADER REFRESH LISTENER
document.addEventListener('cart:refresh', function() {
  if (cartRefreshOrigin !== "molde") {
    console.log("✅ cart:refresh escuchado → recargando header vía fetch...");

    fetch(window.location.pathname)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newHeader = doc.querySelector('header');

        if (newHeader) {
          document.querySelector('header').innerHTML = newHeader.innerHTML;
          console.log("✅ Header reemplazado dinámicamente.");
        } else {
          console.warn("⚠️ No se encontró el header en la respuesta HTML.");
        }
      })
      .catch(err => {
        console.error("❌ Error updating header:", err);
      });
  }
});

// Trigger final cart refresh after all molds are processed
document.addEventListener('DOMContentLoaded', function() {
  let moldsProcessedCount = 0;
  
  const originalAddMoldePorImagen = addMoldePorImagen;
  addMoldePorImagen = function(variantId, imageUrl, moldFeeType, callback) {
    originalAddMoldePorImagen(variantId, imageUrl, moldFeeType, function() {
      callback();
      moldsProcessedCount++;
      
      // Trigger cart refresh after all molds are processed
      setTimeout(() => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      }, 100);
    });
  };
});